import { render } from "./GameTitle.vue?vue&type=template&id=180dddb2&scoped=true&ts=true"
import script from "./GameTitle.vue?vue&type=script&lang=ts"
export * from "./GameTitle.vue?vue&type=script&lang=ts"

import "./GameTitle.vue?vue&type=style&index=0&id=180dddb2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/levelpro-feed-widget/levelpro-feed-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180dddb2"]])

export default __exports__